/* 10-19 Filigree: free Honey Bee Jar under-$100 warning (cart drawer + /cart page).
   Intercepts qty decrease / remove BEFORE the change is sent; checks applied codes after load/refresh.
   Never adds the jar. Eligible total = every non-jar line's final_line_price (same rule as main-cart-v2). */
(function(){
  if(window.__fgJarWarn)return;window.__fgJarWarn=true;
  var JAR='honey-bee-jar-with-dipper',TH=10000;
  var MSG='Applying this will bring your order under $100 and you will lose the free Honey Bee Jar.';
  var bypass=false;
  function getCart(){return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();});}
  function jarFree(c){return c.items.some(function(i){return i.handle===JAR&&i.final_line_price===0;});}
  function eligible(c){var s=0;c.items.forEach(function(i){if(i.handle!==JAR)s+=i.final_line_price;});return s;}
  /* Tested 10-19: Shopify keeps the jar $0 after an ORDER code (CART10 on $109.98 -> $98.99, jar still free),
     so only line-level (product) discounts count against the $100. */
  function after(c){return eligible(c);}
  function box(extra){var d=document.createElement('div');d.className='fg-jarwarn '+(extra||'');d.setAttribute('role','alert');d.setAttribute('data-jar-warning','');
    d.innerHTML='<p class="fg-jarwarn__msg">🐝 '+MSG+'</p>';return d;}
  function confirmAt(row,go,keep){
    document.querySelectorAll('[data-jar-warning]:not([data-jar-warning-code])').forEach(function(n){n.remove();});
    var d=box();
    d.insertAdjacentHTML('beforeend','<div class="fg-jarwarn__row"><button type="button" class="fg-jarwarn__btn fg-jarwarn__keep">Keep my jar</button><button type="button" class="fg-jarwarn__btn fg-jarwarn__go">Remove anyway</button></div>');
    d.querySelector('.fg-jarwarn__keep').addEventListener('click',function(e){e.stopPropagation();d.remove();if(keep)keep();});
    d.querySelector('.fg-jarwarn__go').addEventListener('click',function(e){e.stopPropagation();d.remove();go();});
    if(row&&row.parentNode)row.parentNode.insertBefore(d,row.nextSibling);else document.body.prepend(d);
    d.scrollIntoView({block:'nearest',behavior:'smooth'});
  }
  function target(t){
    var b;
    if((b=t.closest('.cart-drawer__body [data-qty-change="-1"]')))return{el:b,key:b.dataset.key,units:1,row:b.closest('.cart-drawer__item')};
    if((b=t.closest('.cart-drawer__body [data-remove-key]')))return{el:b,key:b.dataset.removeKey,units:'all',row:b.closest('.cart-drawer__item')};
    if((b=t.closest('.cart-line [data-qty-minus]'))){var w=b.closest('.cart-line__qty');var i=w&&w.querySelector('[data-quantity-input]');if(!i)return null;return{el:b,key:w.getAttribute('data-key'),units:1,row:b.closest('.cart-line')};}
    if((b=t.closest('.cart-line .cart-line__remove')))return{el:b,key:b.getAttribute('data-key'),units:'all',row:b.closest('.cart-line')};
    return null;
  }
  function check(key,newQty,units){
    return getCart().then(function(c){
      if(!jarFree(c))return false;
      var keys=String(key).split(',');
      var ls=c.items.filter(function(i){return keys.indexOf(i.key)>-1&&i.handle!==JAR;});if(!ls.length)return false;
      var tq=0,tp=0;ls.forEach(function(i){tq+=i.quantity;tp+=i.final_line_price;});
      var q=(units==='all')?0:(newQty!=null?newQty:tq-units);
      var drop=(tp/tq)*(tq-Math.max(0,q));
      return drop>0&&after(c)-drop<TH;
    }).catch(function(){return false;});
  }
  /* 10-20 bag fix: "Remove anyway" also takes the free jar out, in the SAME update, so a paid jar is never left behind. */
  function dropJarThen(go){
    getCart().then(function(c){
      var j=c.items.filter(function(i){return i.handle===JAR;})[0];
      if(!j){go();return;}
      var up={};up[j.key]=Math.max(0,j.quantity-1);
      return fetch("/cart/update.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({updates:up})}).then(function(){try{sessionStorage.removeItem("fgJarFree");}catch(x){}go();});
    }).catch(function(){go();});
  }
  /* Safety net: if the jar was free and is now charged because the eligible total fell under $100, remove the gift unit. */
  function jarGuard(){
    getCart().then(function(c){
      var j=c.items.filter(function(i){return i.handle===JAR;})[0];var ss;try{ss=sessionStorage;}catch(x){ss=null;}
      if(!j){if(ss)ss.removeItem("fgJarFree");return;}
      if(j.final_line_price===0){if(ss)ss.setItem("fgJarFree","1");return;}
      if(ss&&ss.getItem("fgJarFree")==="1"&&eligible(c)<TH){
        ss.removeItem("fgJarFree");var up={};up[j.key]=Math.max(0,j.quantity-1);
        fetch("/cart/update.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/json"},body:JSON.stringify({updates:up})}).then(function(){
          if(document.querySelector(".cart-page"))window.location.reload();else if(window.fgDrawerRefresh)window.fgDrawerRefresh();
        });
      }
    }).catch(function(){});
  }
  document.addEventListener("DOMContentLoaded",function(){setTimeout(jarGuard,300);});
  document.addEventListener("cart:updated",function(){setTimeout(jarGuard,600);});
  document.addEventListener("cart:open",function(){setTimeout(jarGuard,600);});
  window.fgJarGuard=jarGuard;
  document.addEventListener('click',function(e){
    if(bypass||!e.target.closest)return;
    var t=target(e.target);if(!t||!t.key)return;
    e.preventDefault();e.stopImmediatePropagation();
    check(t.key,null,t.units).then(function(warn){
      var go=function(){bypass=true;try{t.el.click();}finally{bypass=false;}};
      if(warn)confirmAt(t.row,function(){dropJarThen(go);});else go();
    });
  },true);
  document.addEventListener('change',function(e){
    if(bypass||!e.target.closest)return;
    var inp=e.target.closest('.cart-line [data-quantity-input]');if(!inp)return;
    var w=inp.closest('.cart-line__qty');var q=parseInt(inp.value,10);if(isNaN(q)||q<0)q=0;
    var old=inp.defaultValue;
    e.stopImmediatePropagation();
    check(w.getAttribute('data-key'),q,null).then(function(warn){
      var go=function(){bypass=true;try{inp.dispatchEvent(new Event('change',{bubbles:true}));}finally{bypass=false;}};
      if(warn)confirmAt(inp.closest('.cart-line'),function(){dropJarThen(go);},function(){inp.value=old;});else go();
    });
  },true);
  /* Codes: the cart has no code box (codes are typed at checkout), but /discount/CODE links apply one
     to the cart. If an applied order code takes the eligible total under $100 while the jar is in the cart, say so. */
  function codeCheck(){
    getCart().then(function(c){
      document.querySelectorAll('[data-jar-warning-code]').forEach(function(n){n.remove();});
      var hasJar=c.items.some(function(i){return i.handle===JAR;});
      var code=(c.cart_level_discount_applications||[]).some(function(a){return a.type==='discount_code';})||c.items.some(function(i){return (i.line_level_discount_allocations||[]).some(function(a){return a.discount_application&&a.discount_application.type==='discount_code';});});
      if(!hasJar||!code)return;
      if(after(c)<TH){
        ['.cart-drawer__body','.cart-page'].forEach(function(s){var p=document.querySelector(s);if(!p)return;
          var d=box('fg-jarwarn--banner');d.setAttribute('data-jar-warning-code','');p.prepend(d);});
      }
    }).catch(function(){});
  }
  document.addEventListener('DOMContentLoaded',codeCheck);
  document.addEventListener('cart:updated',function(){setTimeout(codeCheck,400);});
  document.addEventListener('cart:open',function(){setTimeout(codeCheck,400);});
  window.fgJarCodeCheck=codeCheck;
})();
